/**
 * @file 路由鉴权守卫
 * @description 按 localStorage `AUTH_TOKEN` 控制可访问页面。
 *
 * @whenToUse 包裹需登录的业务路由，或限制已登录用户访问登录页。
 * @whenNotToUse 按钮级权限、接口权限（另做能力校验）。
 */

import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { isAuthenticated } from '@/lib/auth.ts'

/**
 * 未登录时跳转 `/login`；已登录则渲染子路由。
 */
export function RequireAuth() {
  const location = useLocation()

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}

type GuestOnlyProps = {
  /** 未登录时可渲染的内容（通常为登录页） */
  children: ReactNode
}

/**
 * 已登录访问登录页时跳转 `/`；未登录则渲染 children。
 */
export function GuestOnly({ children }: GuestOnlyProps) {
  if (isAuthenticated()) {
    return <Navigate to="/" replace />
  }

  return children
}
